import util from '@bmp-vue/core/api/util'

const controller = 'Movimentos'
export default {
  ExisteMovimento: function (dto) {
    return util.Axios.GetAll(controller + '/ExisteMovimento', dto)
  }
}
